// =============================================================================
// Darkfeld Theme Definitions — managed by Button the gnome illusionist.
// CSS custom properties (RGB triplets) are defined in globals.css per theme id.
// The `swatch` array provides three hex preview colors for the picker UI.
// =============================================================================

export interface ThemeDef {
  id:          string;
  label:       string;
  description: string;
  isDefault?:  boolean;
  /**
   * Three hex preview colors: [accent, card-bg, page-bg].
   * Used only in the theme picker swatches — not applied to the document.
   */
  swatch: readonly [string, string, string];
}

export const THEMES: readonly ThemeDef[] = [
  {
    id:          'darkfeld',
    label:       'Darkfeld',
    description: 'Classic gold on dark — the realm as it was meant to be seen.',
    isDefault:   true,
    swatch:      ['#c9a84c', '#1e2330', '#0d0f12'],
  },
  {
    id:          'darkfeld-hc',
    label:       'Darkfeld (High Contrast)',
    description: 'Brighter gold & white for improved readability and accessibility.',
    swatch:      ['#d4b856', '#1a1f28', '#0d0f12'],
  },
  {
    id:          'arcane',
    label:       'Arcane',
    description: 'Deep violet — the pure expression of illusionist purple.',
    swatch:      ['#a78bfa', '#1c1434', '#0b0814'],
  },
  {
    id:          'twilight',
    label:       'Twilight',
    description: 'Indigo midnight — where the stars dissolve into the void.',
    swatch:      ['#818cf8', '#14182e', '#080914'],
  },
  {
    id:          'ember',
    label:       'Ember',
    description: 'Smouldering orange, wreathed in shadow-purple.',
    swatch:      ['#fb923c', '#241430', '#0e0812'],
  },
  {
    id:          'void',
    label:       'Void',
    description: 'Pure black, shot through with fuchsia starlight.',
    swatch:      ['#e879f9', '#120a1e', '#06040a'],
  },
] as const;

export const DEFAULT_THEME_ID = 'darkfeld';

export function getTheme(id: string): ThemeDef {
  return THEMES.find((t) => t.id === id) ?? THEMES[0];
}
